import React from 'react';
import { Notification } from 'components/Notification/Notification';

const Alert = props => {
  return (
    <div className="padTB24">
      {' '}
      <Notification
        type={props.type}
        id={1}
        isInline={true}
        description={props.message}
        open={true}
        notClosable={true}
        transient
        className="format100"
      />
    </div>
  );
};

export default Alert;
